// @module NXTurn.ShoppingExtensions.PDP
define('C3.ShoppingExtensions.PDP.CompleteYourKitFunctionality.View'
,	[
	'c3_shoppingextensions_pdp_completeyourkitfunctionality.tpl'
	
	,	'C3.ShoppingExtensions.PDP.CompleteYourKit.Model'
	,   'AjaxRequestsKiller'
	,	'Backbone'
	,	'Backbone.View'
	,   'Utils'	
	,   'Backbone.CollectionView'
	,   'backbone_collection_view_row.tpl'
	,   'C3.ShoppingExtensions.PDP.CompleteYourKitItems.View'
	,	'C3.ShoppingExtensions.PDP.CompleteYourKitItems.Collection'
	,	'C3.ShoppingExtensions.PDP.CompleteYourKitFunctionality.List.View'
	,	'C3.ShoppingExtensions.PDP.CompleteYourKitItems.CellView'
	,	'LiveOrder.Model'
	,	'GoogleTagManager'
	,	'Tracker'
    ]
, function (
	c3_shoppingextensions_pdp_completeyourkitfunctionality_tpl
	
	,	CompleteYourKitModel
	,   AjaxRequestsKiller
	,	Backbone
	,	BackboneView
	,   Utils
	,   BackboneCollectionView
	,   backbone_collection_view_row_tpl
	,   CompleteYourKitItemsView
	,	CompleteYourKitItemsCollection
	,	CompleteYourKitFunctionalityListView
	,	CompleteYourKitFunctionalityItemsCellView
	,	LiveOrderModel
	,   GoogleTagManager
	,	Tracker
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.PDP.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_pdp_completeyourkitfunctionality_tpl

	,	initialize: function (options) {
			this.application = options.application;
			this.layout = options.layout;
			this.iteminfo = options.iteminfo;
			this.configuration = options.configuration;
			this.container = options.container;
			this.pdpConfig = this.configuration.PDP.config;
			
		}
	,  render: function(){	
		var self = this;
		
		var item_info = this.iteminfo
		,   item = item_info.item
		,   itemtype = item.itemtype
		,   item_id = item.internalid
		,	itemPDPCategory= item.custitem_pdp_category
		,	itemPDPCategoryImage = item.custitem_pdp_image;
		//console.log('itemPDPCategory is'+itemPDPCategory);
		
		if(itemPDPCategory && itemPDPCategory !=null)
		{
			var model = new CompleteYourKitModel();
			self.itemPDPCategoryImage = itemPDPCategoryImage;
			model.fetch({
				data: {
					requestType :'ALL'
				,	itemPDPCategory : itemPDPCategory
	            },
	            killerId: AjaxRequestsKiller.getKillerId()
			}).done(function (res)
		      {
		       // console.log(res)
		      	//Kit up functionality section
		      	var completeYourKitData = res.completeYourKitCategoriesResponse;
		      	
		      	if(completeYourKitData.itemData && 
		      						completeYourKitData.itemData.length > 0)
		      		var itemData = completeYourKitData.itemData.filter(function(item, pos, self) {
				    	return self.indexOf(item) == pos;
					})
		      	if(completeYourKitData.subcategoriesData&& 
		      						completeYourKitData.subcategoriesData.length > 0)
		      	{
		      		var subcategoriesData = completeYourKitData.subcategoriesData.filter((o, index, arr) =>
					    arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
					);
			      	self.completeYourKitItems = itemData;
			      	self.completeYourKitCategories = subcategoriesData;
			      	self._render(); 
		      	}
		      });
			}
		}		
	,	events: {
			'click [data-action="complete-kit-click"]': 'arrowClicked',
			'click [data-action="complete-your-kit-onclick-item-view"]': 'onClickCategoryItemsRenderView'
		}	
	,   arrowClicked: function arrowClicked(e){
    	
    	const anchor = jQuery(e.currentTarget)
    	,     data_attr = anchor.attr('data-click')
	    ,     sibling = anchor.siblings()

	    //console.log(anchor)
	    if(data_attr == 'right-click')
	    {
	    	//console.log(anchor.hasClass('disabled'))
	    	//console.log(sibling.hasClass('disabled'))
	    	if(anchor.hasClass('disabled'))
	    	{
	    		$('.pdp-completekit.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
	    	}

	    	if(sibling.hasClass('disabled'))
	    	{
	    		$('.pdp-completekit.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')	    		
	    	}
	    	else
	    	{
	    		$('.pdp-completekit.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg')
	    	}
	    }
	    else if(data_attr == 'left-click')
	    {
	    	if(anchor.hasClass('disabled'))
	    	{
	    		$('.pdp-completekit.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')
	    	
	    	}
	    	if(sibling.hasClass('disabled'))
	    	{
	    		$('.pdp-completekit.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
	    	}
	    	else
	    	{
	    		$('.pdp-completekit.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg')
	    	}
	    }
	   
    }	

	,	bindings: {
		}

	, 	childViews: {
			'CompleteYourKit.Items' : function (){
				//console.log(this.kitupitems)
				var self = this;
				return new CompleteYourKitItemsView({
			          itemsIds: this.completeYourKitItems,
			          application: self.application,
			          configuration : self.configuration,
			          container : self.container,
			          parentItemInfo: this.iteminfo		        
			        });
			}
		}
	,	onClickCategoryItemsRenderView :function(e)
		{	
			//this.destroy();
			var self = this;
			var targetElement = jQuery(e.target);
			
			var categoryID = targetElement.attr("data-category-id");
			var categoryContentPanelID = '#category-tab-content-'+categoryID;
			
			if(jQuery(categoryContentPanelID).html()=="")
			{
				self.resetEvents();
				jQuery(categoryContentPanelID).html('Loading...');
				var completeYourKitModel = new CompleteYourKitModel();
			
				completeYourKitModel.fetch({
					data: {
						requestType :'SINGLE'
					,	itemPDPSingleCategoryID : categoryID
		            },
		            killerId: AjaxRequestsKiller.getKillerId()
				}).done(function (res)
			      {
			        //console.log(res)
			      	var completeYourKitItemsData = res.completeYourKitCategoryItemsResponse;
			      	if(completeYourKitItemsData && 
			      						completeYourKitItemsData.length > 0)
			      	{
			      		
				        const collection = new CompleteYourKitItemsCollection({ 
				        					itemsIds: completeYourKitItemsData})
			      		collection.fetchItems().done(function(itemData) {

			      			var view = new CompleteYourKitFunctionalityListView({
			          					collection : collection,
			          					application : self.application,
			          					configuration : self.configuration,
      									iteminfo :self.iteminfo,
      									origin : 'CompleteYourKit-Items-Tab-'+categoryID
			          		});
			      			//console.log(itemData)
			      			jQuery(categoryContentPanelID).html(view._render().$el.html());
			      			
			      			self.bindEvents();

			      			setTimeout(function() {
				                //if(collection.length > 4) //slider if only more than 4
				                //{
				                    const carousel = self.$el.find('[data-type="carousel-items"]');

				                    const {
				                        siteSettings,
				                        imageSizeMapping,
				                        bxSliderDefaults
				                    } = self.options.application.getConfig();

				                    if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
				                        const img_min_height = (_.where(siteSettings.imagesizes, {
				                            name: imageSizeMapping.thumbnail
				                        })[0]).maxheight;

				                        carousel
				                            .find('.item-relations-related-item-thumbnail')
				                            .css('minHeight', img_min_height);
				                    }
				                    
				                    //bxSliderDefaults.slideWidth = 256;
				                    bxSliderDefaults.maxSlides = 5;
				                    //console.log(itemData.items)
				                    if(itemData.items.length >= 6)
				                    {
				                      bxSliderDefaults.controls = true;  
				                      bxSliderDefaults.slideWidth = 252;
				                    }
				                    else{
				                       bxSliderDefaults.slideWidth = 262;
				                       bxSliderDefaults.controls = false;  
				                    }
				                    

				                    bxSliderDefaults.hideControlOnEnd = true;
				                    bxSliderDefaults.prevText = '<a data-click="left-click" data-action="pdp-sub-completekit-click" class="pdp-sub-completekit carousel-items-prev-icon"><img class="left-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg"></a>';
				                    bxSliderDefaults.nextText = '<a data-click="right-click" data-action="pdp-sub-completekit-click" class="pdp-sub-completekit carousel-items-next-icon"><img class="right-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';
				            
				                    /*bxSliderDefaults.prevText = '<a class="carousel-items-prev-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg"></a>';
				                    bxSliderDefaults.nextText = '<a class="carousel-items-next-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';
				                *///bxSliderDefaults.touchEnabled = false;
				                   //console.log(self.collection.length)
				                    bxSliderDefaults.infiniteLoop = false;
				                    /*bxSliderDefaults.hideControlOnEnd = true;
				                    bxSliderDefaults.auto = false;*/
				                    Utils.initBxSlider(carousel, bxSliderDefaults);
				               // }
				            });
			      		});
			      	}	
			    });
			//self.undelegateEvents();
			}
		} 
	,	bindEvents:function bindEvents()
		{
			var self = this;
			this.$el.find('[data-action="plus-tab"]').on('click', function(e)
			{
				e.stopPropagation();
				var $element = self.$(e.target);
		        var quantity_input = $element.parent().find('.item-quantity-value');
		        var button_minus = $element.parent().find('.minus-button');
		       	var find_title_ele = $element.closest('.e2');

		       	var cart = self.container.getComponent('Cart');
		    	var lines=[];
		    	
		    	var itemQtyInCurrentOrder = 0;
		    	var liveOrder = LiveOrderModel.getInstance();
				var internalID=quantity_input.attr("data-id");
				var itemOrigin = quantity_input.attr("data-origin");
				debugger;
				var lineData=liveOrder.get('lines').filter(function(line)
				{	
					return line.get('item').get('internalid') == internalID;
		       	});

		       	if(lineData.length > 0)
		       	{
			       	var lineQuantity=lineData[0].get('quantity');
			       	itemQtyInCurrentOrder = lineQuantity;
		       	}

		    	var elementParent = $element.parent('.'+itemOrigin+'.plus-icon');
		    	var trashCane = $element.parent().find('.product-trash-tray');
	    	   	
		    	//debugger
		       // console.log(find_title_ele)
		        quantity_input.show();
		       // button_minus.show();

		        var parentEle = $element.parent('.'+itemOrigin+'.plus-icon');
		        if(!(parentEle.hasClass('expand-plus-icon')))
		        	parentEle.addClass('expand-plus-icon');

		        find_title_ele.addClass('newly-added-css');
		        
		        var old_value = quantity_input.text();

		        if(elementParent.hasClass('add-to-cart-buttons-opened'))
		        {
					var new_val = parseFloat(old_value) == 0 ? 1 : parseFloat(old_value)+1; 
					quantity_input.text(new_val);
				}
				//console.log(old_value)

				var quantity = quantity_input.text();
				var internalID=quantity_input.attr("data-id");

				//console.log(quantity)

				if(quantity == 1)
		        {
		        	trashCane.show();
		        	button_minus.hide();
		        	quantity_input.css('text-align','left');
		        	
		        }
		        else	
		        {
		        	 button_minus.show();
		        	trashCane.hide();
		        	quantity_input.css('text-align','center');
		        }
		        if(quantity>0)
				{
					if(itemQtyInCurrentOrder && !(elementParent.hasClass('add-to-cart-buttons-opened')))
					{
						$element.text('+');
						$element.removeClass('plus-button-additional');

						elementParent.addClass('add-to-cart-buttons-opened');
						elementParent.removeClass('plus-icon-additional');

					}else
					{
						var lineData={quantity: parseFloat(1),
							  		  item: {internalid: parseFloat(internalID)}
						};
						lines.push(lineData);
						SC.loadingIndicatorShow();
						cart.addLines({lines: lines}).then(function() {
							SC.loadingIndicatorHide();
							if(!Utils.isPhoneDevice())
							jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");

							      //Snippet for GTM DataLayer
	                        var cartLinesDL = liveOrder.get('lines')
	                        ,   cartLinesModelsDL = cartLinesDL.models
	                        ,   finalCartArray = []

	                        _.each(cartLinesModelsDL, function(line) {
	                            var lineItem = line.get('item')
	                            ,   lineItemName = lineItem.get('displayname')
	                            ,   lineItemSKU = lineItem.get('itemid')
	                            ,   lineQty = line.get('quantity')
	                            ,   lineRate = line.get('rate')

	                            finalCartArray.push({
	                                'item': lineItemSKU,
	                                'quantity':  lineQty,
	                                'price': lineRate,
	                                'unique_id': lineItemSKU

	                            })
	                        });

	                        const gtm = GoogleTagManager;
	                        const eventName = 'cartInfo';
	                         const eventData = {
	                            event: eventName,
	                            cartUpdates: finalCartArray
	                         }
	                         Tracker.trigger(eventName, eventData);
	                         gtm.pushData(eventData);
	                         //console.log(gtm.win)

	                         console.log(finalCartArray)
	                        /*var _etmc = [];
							_etmc.push(['trackCart', {
							    'cart': finalCartArray
							}]);*/
	                         //setTimeout(function() { 
	                            var appendParentElement = $('.append-abandoned-cart-items')
	                            appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
	                         //}, 1000); 
						});
						elementParent.addClass('add-to-cart-buttons-opened');	
					}
				}
			});
			this.$el.find('[data-action="minus-tab"]').on('click', function(e)
			{
				e.stopPropagation();
				var $element = self.$(e.target);
		        var quantity_input = $element.parent().find('.item-quantity-value');
		       	var find_title_ele = $element.closest('.e2');
		        var old_value = quantity_input.text();
		       	var cart = self.container.getComponent('Cart');
		       	$element.attr('disabled','disabled');
		    	var lines=[];

		     	
		        var internalID=quantity_input.attr("data-id");
		        var itemOrigin = quantity_input.attr("data-origin");
				
				var liveOrder = LiveOrderModel.getInstance();
				
				var lineData=liveOrder.get('lines').filter(function(line)
				{	
					return line.get('item').get('internalid') == internalID;
		       	});
		       	var lineQuantity=lineData[0].get('quantity');

		       //	console.log(lineQuantity)
		       	
		       	if(lineQuantity==1){
		       		liveOrder.removeLine(
		       		lineData[0].set('quantity',parseFloat(lineQuantity)-1));
		       		$element.removeAttr('disabled');
		       	}
		    	else
		    	{
		    		var add_to_cart_promise = liveOrder.updateLine(
		       		lineData[0].set('quantity',parseFloat(lineQuantity)-1));
		       		jQuery.when(add_to_cart_promise).done(function( x ) {
	  					$element.removeAttr('disabled');
	  				});
		    	}

		    	if(old_value==1 )
		        {
		        	var parentEle = $element.parent('.'+itemOrigin+'.plus-icon');
			        if(parentEle.hasClass('expand-plus-icon'))
			        parentEle.removeClass('expand-plus-icon');

			    	if(parentEle.hasClass('add-to-cart-buttons-opened'))
	                parentEle.removeClass('add-to-cart-buttons-opened');

		        	find_title_ele.removeClass('newly-added-css');
		        	var new_val = parseFloat(old_value) - 1;
					

					if(new_val == 0)
	                quantity_input.text(1);
	                else
	                quantity_input.text(new_val);

	            
		        	$element.attr("style","display:none !important;");
		        	quantity_input.hide();
		        }
		        else if(old_value>1 ){
		        	var new_val = parseFloat(old_value) - 1;
		        	quantity_input.text(new_val);

		        	if(old_value == 2)
		        	{
		        		var trashCane = $element.parent().find('.product-trash-tray');
				    	var button_minus = $element.parent().find('.minus-button');
				    	//console.log(button_minus)
				    	button_minus.attr("style","display:none !important;");
				    	trashCane.show();
				    	quantity_input.css('text-align','left');
			        	
		        	}
		        }

	            //Snippet for GTM DataLayer
	            var cartLinesDL = liveOrder.get('lines')
	            ,   cartLinesModelsDL = cartLinesDL.models
	            ,   finalCartArray = []

	            _.each(cartLinesModelsDL, function(line) {
	                var lineItem = line.get('item')
	                ,   lineItemName = lineItem.get('displayname')
	                ,   lineItemSKU = lineItem.get('itemid')
	                ,   lineQty = line.get('quantity')
	                ,   lineRate = line.get('rate')

	                finalCartArray.push({
	                    'item': lineItemSKU,
	                    'quantity':  lineQty,
	                    'price': lineRate,
	                    'unique_id': lineItemSKU

	                })
	            });

	            const gtm = GoogleTagManager;
	            const eventName = 'cartInfo';
	             const eventData = {
	                event: eventName,
	                cartUpdates: finalCartArray
	             }
	             Tracker.trigger(eventName, eventData);
	             gtm.pushData(eventData);
	             //console.log(gtm.win)

	             console.log(finalCartArray)
	            /*var _etmc = [];
				_etmc.push(['trackCart', {
				    'cart': finalCartArray
				}]);*/
	             //setTimeout(function() { 
	                var appendParentElement = $('.append-abandoned-cart-items')
	                appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
	             //}, 1000); 
									
		        if(liveOrder.getTotalItemCount()>0)
		        {
		        	if(!Utils.isPhoneDevice())
		        	jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
		        }
			});
		}
	,	resetEvents : function resetEvents() {
			this.$el.find('[data-action="plus-tab"]').off('click');
			this.$el.find('[data-action="minus-tab"]').off('click');
		}
	,	destroy: function() 
		{
	        BackboneView.prototype.destroy.apply(this, arguments);
	    }
		//@method getContext @return NXTurn.ShoppingExtensions.PDP.View.Context
	,	getContext: function getContext()
		{
			var self = this;
			return {
				categories : this.completeYourKitCategories
			,	itemPDPCategoryImage: this.itemPDPCategoryImage
			};
		}
	});
});
